export default "__VITE_ASSET__e6aae629__"